import { heroPosters, siteStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative scroll-mt-24">
      <div className="absolute inset-0 h-full w-full overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20cinematic%20backdrop%20of%20a%20dark%20movie%20theater%20with%20warm%20amber%20projector%20light%20beams%20and%20floating%20dust%2C%20deep%20green%20shadows%2C%20soft%20bokeh%20particles%20like%20stars%2C%20moody%20atmospheric%20texture%20without%20any%20text&width=1920&height=1200&seq=hero-backdrop-film&orientation=landscape"
          alt=""
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/90"></div>
      </div>

      <div className="relative mx-auto w-full px-4 pt-28 pb-14 md:px-8 md:pt-36 md:pb-20">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-center lg:gap-16">
          <div className="w-full lg:w-1/2">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/15 px-3 py-1 font-label text-xs font-medium tracking-widest text-primary-200">
              <i className="ri-fire-line"></i>
              最新电影 · 热播剧 · 电视剧片库
            </span>
            <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
              星辰影视：最新电影与热播剧一站追个够
            </h1>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
              星辰影视片库收录最新电影、电视剧与热播剧，覆盖科幻、悬疑、剧情、动作、爱情、喜剧、动画等多种类型。
              无论你想追正在更新的热播剧，还是翻出记忆里的经典老剧，都能在这里按类型、按地区快速找到想看的那一部。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#movies"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-600"
              >
                <i className="ri-film-line text-base"></i>
                浏览电影大全
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-trophy-line text-base"></i>
                查看追剧榜单
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {siteStats.map((stat) => (
                <div key={stat.label} className="rounded-lg border border-background-50/10 bg-background-50/5 p-3">
                  <dt className="flex items-center gap-2 text-xs text-background-200">
                    <i className={`${stat.icon} text-primary-300`}></i>
                    {stat.label}
                  </dt>
                  <dd className="mt-2 font-heading text-lg font-bold text-background-50 md:text-xl">{stat.value}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="w-full lg:w-1/2">
            <div className="grid grid-cols-3 gap-3 md:gap-4">
              {heroPosters.map((poster) => (
                <figure
                  key={poster.id}
                  className="group relative aspect-[3/4] overflow-hidden rounded-lg border border-background-50/10"
                >
                  <img
                    src={poster.poster}
                    alt={`${poster.title} 影视海报`}
                    title={`${poster.title} 影视海报`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-transparent to-transparent"></div>
                  <figcaption className="absolute bottom-0 left-0 right-0 p-2.5">
                    <p className="font-heading text-sm font-bold text-background-50">{poster.title}</p>
                    <p className="truncate text-xs text-background-200">{poster.tag}</p>
                  </figcaption>
                </figure>
              ))}
            </div>
            <p className="mt-4 flex items-center gap-2 text-xs text-background-200">
              <i className="ri-information-line"></i>
              海报与片单为本页示例内容，用于展示浏览与筛选体验。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}